import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Flex } from 'reflexbox'
import {
  lifecycle,
  compose,
} from 'recompose'
import _ from 'lodash'
import injectSagas from 'helpers/injectSagas'

import Layout from './Layout'
import Panel from './Panel'
import DashboardCard from './DashboardCard'
import ChartFilter from './ChartFilter'
import DashboardQuery from './DashboardQuery'
import CollapsableCard from './CollapseCard'
import DashboardOptions from './DashboardOptions'

import {
  MODULE_NAME,
} from './constants'
import {
  mount,
  unmount,
  resetQueryAction,
  toggleDashboardQuery
} from './actions'
import {
  reportsSelector,
  dashboardQueryUISelector
} from './selectors'
import sagas from './sagas'

const mapStateToProps = (state) => {
  return {
    reports: reportsSelector(state),
    dashboardQueryCollapse: dashboardQueryUISelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    mount: () => dispatch(mount()),
    unmount: () => dispatch(unmount()),
    resetQuery: (reports) => dispatch(resetQueryAction(reports)),
    toggleCollapse: () => dispatch(toggleDashboardQuery())
  }
}

class Dashboard extends Component {
  onReset = () => {
    const {
      reports,
    } = this.props
    this.props.resetQuery(reports)
  }

  onToggle = () => {
    const {
      toggleCollapse,
    } = this.props
    toggleCollapse()
  }

  render() {
    const {
      dashboardQueryCollapse,
    } = this.props

    return (
      <Layout>
        <Panel>
          <CollapsableCard
            title={"Dashboard"}
            collapse={dashboardQueryCollapse}
            onRefresh={this.onReset}
            outCollapse={<DashboardOptions />}
            inCollapse={<DashboardQuery />}
            onCollapseToggle={this.onToggle}
          >
          </CollapsableCard>
          <Flex>
            <ChartFilter />
            <DashboardCard />
          </Flex>
        </Panel>
      </Layout>
    )
  }
}

const withLifecycle = lifecycle({
  componentDidMount() {
    this.props.mount()
  },
  componentWillUnmount() {
    this.props.unmount()
  }
})

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({ [MODULE_NAME]: sagas })
const enhance = compose(
  withSagas,
  withConnect,
  withLifecycle
)

export default enhance(Dashboard)
